export default __webpack_public_path__ + "static/media/liquidity_provider_icon.bb127e78.png";